/**
 * Control-plane liveness via controlApi (direct, JWT). Drives the console status
 * pill. The control plane exposes an OPEN `/api/v1/healthz` (same liveness as the
 * root `/healthz` k8s probe) so the versioned client reaches it with no
 * version-stripping. `serviceId` is kept only to scope the react-query cache.
 */
import { useQuery } from '@tanstack/react-query';
import { controlApi } from '@/api/client';
import { aesKeys } from './_shared';

export interface AesHealth {
  ok: boolean;
}

export function useAesHealth(serviceId: string | undefined, refreshMs = 15_000) {
  return useQuery<AesHealth>({
    queryKey: aesKeys.health(serviceId ?? ''),
    enabled: !!serviceId,
    refetchInterval: refreshMs,
    retry: false,
    queryFn: async () => {
      const res = await controlApi.get('/healthz', { responseType: 'text' });
      return { ok: res.status === 200 };
    },
  });
}
